import request from '@/utils/request'
import axios from 'axios'
import {
  getToken
} from '@/utils/auth'
const BaseUrl = '/skill-support-applyfor-notarize'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 10000
})
// 保存任务
export function addForm(data) {
  return request({
    url: "/skill-support-applyfor-notarize",
    method: 'post',
    data
  })
}

// 通过id删除任务
export function deleteId(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'delete',
  })
}

// 通过id获取详情
export function idQuery(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'get',
  })
}

// 修改任务
export function updatedForm(data) {
  return request({
    url: "/skill-support-applyfor-notarize",
    method: 'put',
    data
  })
}
// 导出
export function downloadExcel(url, params, label, date) {
  service({
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      filename: 'utf-8',
    },
    params
  }).then(res => {
    const fileName = `${label}.xls`
    const url = window.URL.createObjectURL(res.data)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    document.body.appendChild(link)
    link.setAttribute('download', fileName)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }).catch(error => {
    console.log(error)
  })
}
